import { render, staticRenderFns } from "./SubmitEnrollment.vue?vue&type=template&id=1552670f&scoped=true"
import script from "./SubmitEnrollment.vue?vue&type=script&lang=js"
export * from "./SubmitEnrollment.vue?vue&type=script&lang=js"
import style0 from "./SubmitEnrollment.vue?vue&type=style&index=0&id=1552670f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552670f",
  null
  
)

export default component.exports